module.exports = __webpack_public_path__ + "media/images/app-day-0e69fc3c9c032c4c721c8f196fcb55c8.png";